import Tab, { TabProps } from '@mui/material/Tab';
import { makeStyles } from 'tss-react/mui';
import Link from 'next/link';
import React from 'react';
import palette from '@ui/palette';

interface NavTabProps extends TabProps<'a'> {
  href: string;
}

const useStyles = makeStyles()(theme => ({
  navTab: {
    textDecoration: 'none',

    width: 'fit-content',
    minWidth: 'fit-content',
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5, 2),
    marginRight: theme.spacing(1),
    fontWeight: 700,
    '&:focus': {
      outline: `2px solid ${palette.mint_200}`,
      outlineOffset: `-2px`,
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#1F1F1F',
    },
  },
}));

const NavTab = (props: NavTabProps) => {
  const { href } = props;
  const { classes } = useStyles();
  return (
    <Link href={href} passHref legacyBehavior>
      <Tab className={classes.navTab} {...props} />
    </Link>
  );
};

export default NavTab;
